import { CCardFooter } from "@coreui/react";
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, MenuItem, Select, SelectChangeEvent, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import {AttachFile, Delete} from '@mui/icons-material'
import { T_Inquery } from "../../common/model/InqueryModel";
import apis from "../../common/apis";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import { useProgress } from "../../provider/ProgressContextProvider";
export default function InqueryEdit(){
    const { state } = useLocation();
    // state.inqueryData 에서 넘어온 item 객체를 꺼낼 수 있습니다.
    const inqueryData = state?.item;

    const nav = useNavigate();
    const [cstatus ,setCstatus] = useState('0');
    const [manager ,setManager] = useState('0');
    const [data,setData] = useState<T_Inquery>(inqueryData);
    const {alert,setAlert} = useAlert();
   const {showProgress,setShowProgress} = useProgress();


    const handleChange = (event: SelectChangeEvent) => {
      setCstatus(event.target.value);
      setData({...data,status:event.target.value});
      };
    const handleChangeManager = (event: SelectChangeEvent) => {
      setManager(event.target.value);
      };

      const [selectedFiles, setSelectedFiles] = useState<File[]>([])

      const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>,
      ) => {
        if (!event.target.files) return
        setSelectedFiles(Array.from(event.target.files))
      }    

      const handleRemoveFile = (index: number) => {
        setSelectedFiles(prev =>
          prev.filter((_, i) => i !== index)
        )
      }

      const handleDeleteFile = (index:number,name:string) => { // 실제 DB FILE 삭제
          setAlert({...alert,visible:true,title:"확인",msg:name+" 해당파일을 정말로 삭제하시겠습니까?",buttonList:[{text:"예",onPress:async()=>{
            const result = await apis.common.fileDelete({idx:index})
            if(result.code=="1"){
//              setAlert({...alert,visible:true,msg:"삭제 되었습니다."})
              setAlert(initialAlert);
              getData();
            }

          }
          },{text:"아니요",onPress:()=>{
            setAlert(initialAlert);
          }}]})
      }

      const saveData = async()=>{

        if(data.title === "" || data.title === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"제목을 입력하여 주십시요"})   
            return;
        }
        if(data.contents == "" || data.contents === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"내용을 입력하여 주십시요"})   
            return;
        }
         
        setAlert({...alert,title:"확인",msg:"정말로 수정 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{

                  setShowProgress(true);
                  try{
                        // prev.files만 분리, 나머지는 rest에
                      const { files, ...payload } = data

                      console.log("inquery data:",data)
                    const result = await apis.inquery.inqueryEdit({...payload,filelist:selectedFiles})   
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정이 완료되었습니다."})
                        getData();
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정중 오류가 발생했습니다.."})
                    }
                  }catch(e:any){
                     setAlert(initialAlert);
                          setAlert({...alert,visible:true,title:"확인",msg:"수정중 오류가 발생했습니다."})
                    
                  }

                  setShowProgress(false);
                  
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})

      }


      const getData = async()=>{
         const result = await apis.inquery.inqueryInfo({idx:inqueryData.idx})
         console.log("info:",result)
         if(result.code=="1"){
            setData(result.data);
         }
      }

    return(
    <>
    <Card >
        <CardHeader title="고객문의 변경" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          제목
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField  size="small" fullWidth value={data.title || ''} onChange={(event)=>{setData({...data,title:event.target.value})}} />
                        </TableCell>      

        </TableRow>        

        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          문의내용
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.contents || ''} onChange={(event)=>{setData({...data,contents:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          답변
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.pmethod || ''} onChange={(event)=>{setData({...data,pmethod:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>
                                    <TableCell component="th" scope="row" sx={{width:150}}>
                          파일첨부
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                        <Button
                        variant="contained"
                        component="label"
                        startIcon={<AttachFile />}
                        >
                        파일 선택
                        <input
                            type="file"
                            hidden
                            multiple                        // 여러 파일 선택허용
                            onChange={handleFileChange}
                        />
                        </Button>
                        {selectedFiles.length == 0 && data.files?.map((fileitem,idx)=>{
                            return(<Box  
                                  key={idx}
                                 sx={{
                                 display: 'flex',
                                 alignItems: 'center',
                                 mt: 0.5,
                               }}><Typography>{fileitem.fileOrgNm}</Typography>
                            <IconButton
                            size="small"
                            onClick={() => fileitem.fileOrgNm && handleDeleteFile(fileitem.idx,fileitem.fileOrgNm)}
                            >
                            <Delete fontSize="small" />
                            </IconButton>       
                            </Box>
                            )
                        })}
                        {/* 선택된 파일명 리스트 */}
                        {selectedFiles.length > 0 && (
                        <Box mt={1}>
                            {selectedFiles.map((file, idx) => (
                               <Box
                               key={idx}
                               sx={{
                                 display: 'flex',
                                 alignItems: 'center',
                                 mt: 0.5,
                               }}
                             >    
                            <Typography
                                variant="body2"
                                key={idx}
                            >
                                {file.name}
                            </Typography>
                            <IconButton
                            size="small"
                            onClick={() => handleRemoveFile(idx)}
                            >
                            <Delete fontSize="small" />
                            </IconButton>
                          </Box>
                            ))}
                        </Box>
                        )}                            
                        </TableCell>      
           

        </TableRow>        
 <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          담당자 지정
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={manager}
                            onChange={handleChangeManager}
                            size="small"
                        >
                            <MenuItem value={0}>담당자1</MenuItem>
                            <MenuItem value={1}>담당자2</MenuItem>
                        </Select>
                        </TableCell>      

        </TableRow>        
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          상태
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={data.status}
                            onChange={handleChange}
                            size="small"
                        >
                            <MenuItem value={0}>접수대기</MenuItem>
                            <MenuItem value={1}>접수</MenuItem>
                            <MenuItem value={2}>처리대기</MenuItem>
                            <MenuItem value={3}>처리완료</MenuItem>
                            <MenuItem value={4}>처리취소</MenuItem>
                        </Select>
                        </TableCell>      

        </TableRow>        
        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained" onClick={()=>{
        saveData();
    }}>저장</Button>
        <Button variant="outlined" onClick={()=>{
        nav(-1);
    }}>취소</Button>

        </CCardFooter>
    </Card>

    </>)
}

